import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import { Link } from 'react-router-dom';

class User extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			user: {
				USERID: ''
			},
			userColumns: this.filterColumns(userColumns),
			piSelect: [],
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadPISelect(() => {
			this.loadUser();
		});
	}
	
	userIsAuthorized() {
		// if this is a regular FAS user
		if (('' + this.props.user.uid).startsWith('fas.user.')) {
			// user can only view their own profile
			var loggedInUser = +this.props.user.uid.substring(9);
			return (loggedInUser === +this.props.params.userId);
		} else {
			// only other people that should be in here are admins
			return (this.props.user.fas && (this.props.user.fas.authLevel === 1));
		}
	}

	loadPISelect(callback) {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Home/GetFASPISelectView'
		}).done(function (data) {
			if (data.Success) {
				// create array for pi select options
				var piSelect = [
					{
						value: null,
						label: 'Select...'
					}
				];
				
				// for each result in the data
				for (var i = 0; i < data.Data.length; i++) {
					piSelect.push({
						value: data.Data[i].NAME,
						label: self.copyObject(data.Data[i].NAME)
					});
				}
				
				self.mergeState({
					piSelect: piSelect
				}, () => {
					if (callback) callback();
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});	
	}

	loadUser(event) {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/FAS/Search',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'RECH_APPLICATION_VW',
				search: { Attribute: 'USERID', Operator: '=', LongValue: this.props.params.userId },
				pageNumber: -1,
				pageSize: -1
			}
		}).done(function (data) {
			if (data.Success) {
				if (data.Data.length === 1) {
					if (self.userIsAuthorized()) {
						var user = data.Data[0];
					
						// convert from mvc to js
						self.mvc2js(user, userColumns);
							
						self.mergeStateWithArrays({
							user: user,
							userColumns: self.filterColumns(userColumns, user.AFFILIATION),
							renderKey: self.state.renderKey + 1
						}, () => {
							if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
						});
					} else {
						self.showAlert('Permissions Error', 'User not authorized');
					}
				} else {
					self.showAlert('User Error', 'Expected to find 1 user for ID ' + 
						self.props.params.userId + ' but found ' + data.Data.length);
				}
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
		
	onChange(accessor, value) {
		var user = this.copyObject(this.state.user);
		this.setByAccessor(user, accessor, value);
		
		this.setState({
			user: user,
			userColumns: this.filterColumns(userColumns, user.AFFILIATION),
			renderKey: this.state.renderKey + 1
		});
	}

	filterColumns(columns, filterArg) {
		// admin filter is always enforced
		var i;
		var filter = [];
		if (('' + this.props.user.uid).startsWith('fas.admin.') ||
			(this.props.user.fas && (this.props.user.fas.authLevel === 1))) {
			filter.push('admin');
		}
		
		// add whatever filters were passed in
		if (Array.isArray(filterArg)) {
			for (i = 0; i < filterArg.length; i++) filter.push(filterArg[i]);
		} else {
			filter.push(filterArg);
		}
		
		// find which columns match the filter
		var newColumns = [];
		for (i = 0; i < columns.length; i++) {
			if (!columns[i].includedby ||
				(Array.isArray(columns[i].includedby) && columns[i].includedby.some(f => filter.includes(f))) ||
				(columns[i].includedby && filter.includes(columns[i].includedby))) {
				// make a copy of the column
				var newColumn = this.copyObject(columns[i]);
				
				// if this is the PIGRPNAME column
				if (newColumn.accessor === 'PIGRPNAME') {
					// copy pi list to select options
					newColumn.options = this.copyObject(this.state.piSelect);
				}
				
				// add to new list of columns
				newColumns.push(newColumn);
			}
		}

		return newColumns;
	}
	
	validateUser(event, columns, data) {
		if (!this.userIsAuthorized()) {
			return "User is not authorized.";
		} else {
			return this.validate(columns, data);
		}
	}

	onSubmit(event) {
		var self = this;
		var user = this.js2mvc(this.state.user, userColumns);

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/FAS/UpdateApplication',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				application: user
			}
		}).done(function (data) {
			if (data.Success) {
				self.props.parent.showConfirmation(() => {
					return (<>
						User <Link to={'/FAS/Users/' + self.props.params.userId}>{self.props.params.userId}</Link> updated.
					</>);
				});				
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
						  User {this.state.user.USERID}
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<ChemEdit parent={this} user={this.props.user} columns={this.state.userColumns} data={this.state.user}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							validate={(event, columns, data) => this.validateUser(event, columns, data)}
							onSubmit={(event) => this.onSubmit(event)} editable={this.props.editable}>
							<Form.Group as={Row}>
							  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
								{this.props.editable && <Button id="save" variant="warning" type="submit" className="float-end">Save</Button>}
							  </Col>
							</Form.Group>							
						</ChemEdit>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const userColumns = [
	{ Header: 'Affiliation', accessor: 'AFFILIATION', type: 'select',
		options: [{ value: null, label: 'Select...' },{ value: 'chem', label: 'College of Chemistry Users' },
			{ value: 'affil', label: 'UCB or UC Affiliate Users' },{ value: 'non', label: 'Non-UC Users' }] },
	{ Header: 'Lab', accessor: 'FACILITYID', type: 'select',
		options: [{ value: null, label: 'Select...' },{ value: 34, label: 'Microanalytical Facility' },
			{ value: 33, label: 'X-Ray Crystallography' }]}, 
	{ Header: 'First Name', accessor: 'FIRSTNAME', maxlength: 45, required: true },
	{ Header: 'Middle Initial', accessor: 'MIDDLENAME', maxlength: 45 },
	{ Header: 'Last Name', accessor: 'LASTNAME', maxlength: 45, required: true },
	{ Header: 'Phone', accessor: 'PHONE', maxlength: 45, required: true },
	{ Header: 'Email', accessor: 'USERNAME', maxlength: 100, required: true },
	{ Header: 'Password', accessor: 'PASSWORD', maxlength: 20, required: true },
	{ Header: 'Office Room and Building', accessor: 'ROOMBUILD', maxlength: 45, includedby: 'chem', required: true },
	{ Header: 'Campus/Work Address', accessor: 'ADDRESS', includedby: ['affil','non'], maxlength: 45, required: true },
	{ Header: 'Campus/Work City', accessor: 'CITY', includedby: ['affil','non'], maxlength: 45, required: true },
	{ Header: 'Campus/Work State', accessor: 'STATE', includedby: ['affil','non'], maxlength: 45, required: true },
	{ Header: 'Campus/Work Zip', accessor: 'ZIP', includedby: ['affil','non'], maxlength: 45, required: true },
	{ Header: 'Accounts Payable/Admin First Name', accessor: 'ADMINFIRSTNAME', includedby: ['affil','non'], maxlength: 45, required: true },
	{ Header: 'Accounts Payable/Admin Last Name', accessor: 'ADMINLASTNAME', includedby: ['affil','non'], maxlength: 45, required: true },
	{ Header: 'Accounts Payable/Admin Phone', accessor: 'ADMINPHONE', includedby: ['affil','non'], maxlength: 20, required: true },
	{ Header: 'Accounts Payable/Admin Email', accessor: 'ADMINEMAIL', includedby: ['affil','non'], maxlength: 100, required: true },
	{ Header: 'Speedtype', accessor: 'SPEEDCODE', includedby: ['chem','affil'], maxlength: 45, required: true },
	{ Header: 'Grant/Funding Expiration Date', accessor: 'GRANTEXPDATE', includedby: ['chem','affil'], type: 'date', required: true },
	{ Header: 'Billing Account/Chart String', accessor: 'PURCHASEORDER', includedby: ['chem','affil'], maxlength: 100, required: true },
	{ Header: 'Department', accessor: 'DEPARTMENT', includedby: ['chem','affil'], maxlength: 100, required: true },
	{ Header: 'Cal ID Front Card Number', accessor: 'FRONTIDENTITYCARD', includedby: ['chem','affil'], maxlength: 45, required: true },
	{ Header: 'PI', accessor: 'PIGRPNAME', type: 'select', includedby: 'chem', required: true, options: [] },
	{ Header: 'PI Name', accessor: 'PINAME', includedby: 'affil', maxlength: 100, required: true },
	{ Header: 'Organization', accessor: 'ORGANIZATION', includedby: 'non', maxlength: 45, required: true },
	{ Header: 'Organization Tax Id', accessor: 'TAXID', includedby: 'non', maxlength: 45, required: true },
	{ Header: 'Purchase Order', accessor: 'PURCHASEORDER', includedby: 'non', maxlength: 100, required: true },
	{ Header: 'Sign Off Facility Administrator or FSA', accessor: 'SIGNOFFFACILITY', includedby: 'admin', type: 'select',
		options: [{ value: null, label: 'Select...' },{ value: 0, label: 'Denied' },{ value: 1, label: 'Approved' }]},
	{ Header: 'Billing Code/Reference', accessor: 'BILLINGCODE', includedby: 'admin', maxlength: 45 },
	{ Header: 'If denied, please explain reasons', accessor: 'FACILITYREASON', includedby: 'admin', type: 'textarea' }
];

export default withRouter(User);
